export default __webpack_public_path__ + "static/media/css3.64fa1d1c.svg";